import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lookup-category-add',
  templateUrl: './lookup-category-add.component.html',
  styleUrls: ['./lookup-category-add.component.css']
})
export class LookupCategoryAddComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
